export function getMonthLength(curtime){ 
	if(curtime == 'year'){return ''};
					let timearry=curtime.split('-');
					if(timearry[1] == '01' || timearry[1] == '03' ||timearry[1] == '05' || timearry[1] == '07'||timearry[1] == '08' || timearry[1] == '10' || timearry[1] == '12'){
						return '31';
					}else if(timearry[1] == '04' || timearry[1] == '06' ||timearry[1] == '09' || timearry[1] == '11'){
						return '30';
					}else{
						if(timearry[0] / 4  == 0){
								return '29';
						}else{
								return '28';
						} 
					} 
				
		};